import React, {Component} from 'react'
import {Menu} from 'semantic-ui-react'
import UserMenu from './userMenu'
import {S3Image} from '../components/custom-common'

class MainMenu extends Component {
    render() {
        const {center} = this.props;
        return (
            <React.Fragment>
                <Menu fixed='top' secondary pointing className="member-menuContainer">
                    <div className={'menuLogoColumn'}>
                        <S3Image className={"logoMarginLeft"} width={115} height={32} common svg name={'official_logo'}/>
                    </div>
                    <div className={'menuCenterColumn'}>
                         <b>{center}</b>
                    </div>
                    <UserMenu />
                </Menu>
                <div className={"member-header-shadow"}/>
            </React.Fragment>
        )
    }
}

export default MainMenu;